import React, { useCallback, useContext, useEffect, useState } from "react";
import { useDailyEvents } from "../services/daily-utils/useDailyEvents";

import { AppContext } from "../context";
import { provider } from "../layouts/AppWrapper";
import useInterval from "../hooks/useInterval";
import QalortButton from "./Button";
import { useNavigate } from "react-router-dom";

function JoinMeetinButton({
  testID,
  disabled,
  onClick,
  className,
  meetingInfo,
  children,
  ...props
}) {
  return (
    <QalortButton
      data-testid={testID}
      disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        window.open(
          `${window.location.origin}/live/${meetingInfo?.slug}`,
          "_blank"
        );
      }}
      className={className}
      {...props}
    >
      {children}
    </QalortButton>
  );
}

export default JoinMeetinButton;
